(() => {
  const MARGE = 2;
  const SELECTEUR = '.pastilles';
  const SEUIL_GLISSE = 4;

  const etat = (piste) => {
    const debordement = piste.scrollWidth - piste.clientWidth;
    if (debordement <= MARGE) return 'aucun';
    const aGauche = piste.scrollLeft > MARGE;
    const aDroite = piste.scrollLeft < debordement - MARGE;
    if (aGauche && aDroite) return 'deux';
    return aGauche ? 'debut' : 'fin';
  };

  const majFondu = (piste) => {
    const nouveau = etat(piste);
    if (piste.dataset.fondu !== nouveau) piste.dataset.fondu = nouveau;
    const zone = piste.closest('.pastilles-zone');
    if (zone && zone.dataset.fondu !== nouveau) zone.dataset.fondu = nouveau;
  };

  const FLECHES = { avant: 'M 15 4 L 7 12 L 15 20', apres: 'M 9 4 L 17 12 L 9 20' };

  const poserFleches = (piste) => {
    const zone = piste.closest('.pastilles-zone');
    if (!zone || zone.querySelector('.pastilles-fleche')) return;
    if (piste.scrollWidth - piste.clientWidth <= MARGE) return;
    Object.keys(FLECHES).forEach((sens) => {
      const bouton = document.createElement('button');
      bouton.type = 'button';
      bouton.className = 'pastilles-fleche pastilles-fleche--' + sens;
      bouton.setAttribute('aria-hidden', 'true');
      bouton.tabIndex = -1;
      bouton.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" ' +
        'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="' + FLECHES[sens] + '" /></svg>';
      zone.appendChild(bouton);
    });
  };

  const observateurTaille = 'ResizeObserver' in window
    ? new ResizeObserver((entrees) => entrees.forEach((e) => majFondu(e.target)))
    : null;
  const suivies = new WeakSet();

  const suivre = (piste) => {
    if (suivies.has(piste)) return;
    suivies.add(piste);
    majFondu(piste);
    poserFleches(piste);
    if (observateurTaille) observateurTaille.observe(piste);
    piste.querySelectorAll('img').forEach((image) => {
      if (image.complete) return;
      image.addEventListener('load', () => { majFondu(piste); poserFleches(piste); }, { once: true });
    });
  };

  const balayer = (racine) => {
    const cible = racine && racine.querySelectorAll ? racine : document;
    cible.querySelectorAll(SELECTEUR).forEach(suivre);
  };

  document.addEventListener('scroll', (e) => {
    const piste = e.target;
    if (piste instanceof Element && piste.matches(SELECTEUR)) majFondu(piste);
  }, { capture: true, passive: true });

  window.addEventListener('resize', () => balayer(document), { passive: true });

  document.addEventListener('click', (e) => {
    const bouton = e.target.closest && e.target.closest('.pastilles-fleche');
    if (!bouton) return;
    e.preventDefault();
    const piste = bouton.closest('.pastilles-zone').querySelector('.pastilles');
    if (!piste) return;
    const rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
    const pas = Math.min(piste.clientWidth * 0.8, 11.1 * rem);
    piste.scrollBy({ left: bouton.classList.contains('pastilles-fleche--avant') ? -pas : pas, behavior: 'smooth' });
  });

  let glisse = null;

  document.addEventListener('pointerdown', (e) => {
    if (e.pointerType === 'touch') return;
    const piste = e.target.closest && e.target.closest(SELECTEUR);
    if (!piste || piste.scrollWidth - piste.clientWidth <= MARGE) return;
    if (e.target.closest('button, input, select, textarea')) return;
    glisse = { piste, x: e.clientX, depart: piste.scrollLeft, tiree: false };
  });

  document.addEventListener('pointermove', (e) => {
    if (!glisse) return;
    const ecart = e.clientX - glisse.x;
    if (!glisse.tiree) {
      if (Math.abs(ecart) < SEUIL_GLISSE) return;
      glisse.tiree = true;
      glisse.piste.classList.add('pastilles--tiree');
      glisse.piste.setPointerCapture(e.pointerId);
    }
    glisse.piste.scrollLeft = glisse.depart - ecart;
    e.preventDefault();
  });

  const finGlisse = () => {
    if (!glisse) return;
    const piste = glisse.piste;
    if (glisse.tiree) {
      piste.classList.remove('pastilles--tiree');
      const avaler = (ev) => { ev.preventDefault(); ev.stopPropagation(); };
      piste.addEventListener('click', avaler, { capture: true, once: true });
      window.setTimeout(() => piste.removeEventListener('click', avaler, true), 0);
    }
    glisse = null;
  };
  /* Une pastille est un lien avec une image : sans cela, tirer à la souris lance le
     glisser-déposer natif du navigateur, qui interrompt le défilement (pointercancel). */
  document.addEventListener('dragstart', (e) => {
    if (e.target.closest && e.target.closest(SELECTEUR)) e.preventDefault();
  });

  document.addEventListener('pointerup', finGlisse);
  document.addEventListener('pointercancel', finGlisse);

  /* Aperçu au survol : la carte montre le coloris survolé (photo, nom, lien). L'aperçu reste
     tant que la souris est sur la carte (on peut remonter cliquer la photo) et la carte revient à
     son coloris d'origine quand la souris la quitte. Souris uniquement : au doigt, un appui ouvre
     directement le coloris. */
  const survolPossible = window.matchMedia('(hover: hover) and (pointer: fine)');
  const prechargees = new WeakSet();

  const elementsCarte = (carte) => ({
    image: carte.querySelector('.card__media .media > img:first-child'),
    liens: carte.querySelectorAll('.card__heading a'),
  });

  const memoriser = (carte) => {
    if (carte.mfOrigine) return carte.mfOrigine;
    const { image, liens } = elementsCarte(carte);
    carte.mfOrigine = {
      src: image && image.getAttribute('src'),
      srcset: image && image.getAttribute('srcset'),
      alt: image && image.getAttribute('alt'),
      liens: [...liens].map((a) => ({ a, href: a.getAttribute('href'), texte: a.textContent })),
    };
    return carte.mfOrigine;
  };

  const montrer = (carte, pastille) => {
    const { image } = elementsCarte(carte);
    const origine = memoriser(carte);
    if (image && pastille.dataset.apercuSrc) {
      if (pastille.dataset.apercuSrcset) image.setAttribute('srcset', pastille.dataset.apercuSrcset);
      image.setAttribute('src', pastille.dataset.apercuSrc);
      image.setAttribute('alt', pastille.dataset.apercuTitre || '');
    }
    origine.liens.forEach(({ a }) => {
      a.setAttribute('href', pastille.getAttribute('href'));
      if (pastille.dataset.apercuTitre) a.textContent = pastille.dataset.apercuTitre;
    });
    carte.classList.add('card-wrapper--apercu');
  };

  const retablir = (carte) => {
    const origine = carte.mfOrigine;
    if (!origine) return;
    const { image } = elementsCarte(carte);
    if (image) {
      if (origine.srcset) image.setAttribute('srcset', origine.srcset);
      image.setAttribute('src', origine.src);
      image.setAttribute('alt', origine.alt || '');
    }
    origine.liens.forEach(({ a, href, texte }) => {
      a.setAttribute('href', href);
      a.textContent = texte;
    });
    carte.classList.remove('card-wrapper--apercu');
  };

  const precharger = (zone) => {
    if (prechargees.has(zone)) return;
    prechargees.add(zone);
    zone.querySelectorAll('.pastille[data-apercu-src]').forEach((p) => {
      const img = new Image();
      if (p.dataset.apercuSrcset) {
        img.sizes = '(min-width: 1200px) 267px, (min-width: 990px) calc((100vw - 130px) / 4), calc((100vw - 35px) / 2)';
        img.srcset = p.dataset.apercuSrcset;
      }
      img.src = p.dataset.apercuSrc;
    });
  };

  document.addEventListener('pointerover', (e) => {
    if (e.pointerType !== 'mouse' || !survolPossible.matches || glisse) return;
    const zone = e.target.closest && e.target.closest('.pastilles-zone');
    if (!zone) return;
    precharger(zone);
    const pastille = e.target.closest('.pastille');
    const carte = zone.closest('.card-wrapper');
    if (pastille && carte) montrer(carte, pastille);
  });

  document.addEventListener('pointerout', (e) => {
    if (e.pointerType !== 'mouse') return;
    const carte = e.target.closest && e.target.closest('.card-wrapper--apercu');
    if (!carte || (e.relatedTarget && carte.contains(e.relatedTarget))) return;
    retablir(carte);
  });

  if ('MutationObserver' in window) {
    let enAttente = false;
    new MutationObserver((mutations) => {
      if (enAttente) return;
      const nouvelles = mutations.some((m) => [...m.addedNodes].some(
        (n) => n.nodeType === 1 && (n.matches(SELECTEUR) || n.querySelector(SELECTEUR))
      ));
      if (!nouvelles) return;
      enAttente = true;
      requestAnimationFrame(() => { enAttente = false; balayer(document); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  balayer(document);
  window.addEventListener('load', () => balayer(document), { once: true });
  document.addEventListener('shopify:section:load', (e) => balayer(e.target));
})();
